var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSignup = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "62px",
  height: "63px",
  viewBox: "0 0 62 63",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "EC355C43-91E3-4CEE-A591-0BBEA8F7A7F2") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Log-in",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "2-",
  transform: "translate(-142.000000, -155.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(143.000000, 156.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(0.000000, 0.000000)",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M57.5806452,34.5483871 L57.5806452,14.2515417 L57.5806452,9.49671482 C57.5806452,6.88158618 55.4363504,4.74193548 52.8156913,4.74193548 L48.0508566,4.74193548 L23.0322581,4.74193548",
  id: "Path",
  stroke: "#252525"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.7419355,51.483871 L9.49784196,51.3253395 L9.49784196,56.0870197 C9.49784196,57.3964818 9.02881273,58.5869018 8.09075426,59.5392379 C7.2699531,60.3725319 5.98012271,60.9677419 4.69029233,60.9677419 C3.40046194,60.9677419 2.22788885,60.3725319 1.4070877,59.5392379 C0.469029233,58.7059438 0,57.5155238 0,56.2060617 C0,53.5871376 2.11063155,51.4443815 4.69029233,51.4443815 L9.38058465,51.4443815 L9.38058465,16.2580645",
  id: "Path",
  stroke: "#252525"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.4952882,13.4981134 C17.6572936,14.3417463 17.6572936,15.667455 18.4952882,16.5110879 L22.3261209,20.3676952 L26.1569535,24.2243025 C26.9949482,25.0679353 28.3117969,25.0679353 29.1497915,24.2243025 L31.783489,21.572885 L42.6774194,28.4424667 C35.8537487,38.9276177 24.3612507,34.3478966 16.3404448,26.3936441 C8.31968683,18.4393915 3.77057305,6.86958173 14.1856015,0 L21.0092721,10.9672149 L18.4952882,13.4981134 Z",
  id: "Path",
  stroke: "#252525",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.0806452,50.8064516 C26.0806452,46.6666667 29.3611263,43.3548387 33.4617277,43.3548387 L52.5705303,43.3548387 C56.6711318,43.3548387 59.9516129,46.6666667 59.9516129,50.8064516 C59.9516129,54.9462366 56.6711318,58.2580645 52.5705303,58.2580645 L33.4617277,58.2580645 C29.3611263,58.2580645 26.0806452,54.9462366 26.0806452,50.8064516 Z",
  id: "Path",
  stroke: "#FF3F6D"
})))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSignup);
export default ForwardRef;